import { FC } from "react";
import clsx from "clsx";

const MenuBadge: FC<{ text: string; className?: string }> = ({ text, className }) => (
  <span
    className={clsx(
      "h-[14px] rounded-[8px_8px_8px_0] px-[5px] text-[10px] font-bold leading-[14px]",
      "text-[color:var(--base-second)] bg-[linear-gradient(90deg,var(--base-warning-default)_0%,var(--base-primary-default)_100%)]",
      className
    )}
  >
    {text}
  </span>
);

export default MenuBadge;
